import { Location } from '@core/Router/locations';
import { lazy } from 'react';

const ConfigurationPage = lazy(() =>
    import(/* webpackChunkName: "configuration" */ '../ui/ConfigurationPage').then(m => ({
        default: m.ConfigurationPage,
    })),
);
const TranslationDataPage = lazy(() =>
    import(/* webpackChunkName: "configuration" */ '@configuration/ui/TranslationDataPage').then(m => ({
        default: m.TranslationDataPage,
    })),
);

const configurationPath = '/configuration';

export const configurationLocations: Location[] = [
    {
        url: configurationPath,
        Component: ConfigurationPage,
    },
    {
        url: `${configurationPath}/translations`,
        Component: TranslationDataPage,
    },
];
